import React from "react";
import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

const BAND_COLORS = {
  stable: "#34d399",
  watch: "#fbbf24",
  pressure: "#fb923c",
  at_risk: "#f97316",
  critical: "#ef4444",
};

export default function HealthScore({ health, size = "md", onClick, "data-testid": testid }) {
  if (!health || health.score == null) {
    return (
      <div className="font-mono text-xs uppercase tracking-wider text-[var(--fop-text-4)]">
        no data
      </div>
    );
  }
  const color = BAND_COLORS[health.status?.band] || "#9899a5";
  const score = health.score;
  const status = health.status?.label || "—";
  const trend = health.trend || { direction: "stable", label: "0" };
  const TrendIcon =
    trend.direction === "improving" ? ArrowUpRight :
    trend.direction === "declining" ? ArrowDownRight : Minus;
  const trendColor =
    trend.direction === "improving" ? "#34d399" :
    trend.direction === "declining" ? "#ef4444" : "var(--fop-text-3)";

  const variants = {
    xs: { score: "text-base", label: "text-[9px]", trend: "text-[9px]" },
    sm: { score: "text-2xl", label: "text-[9px]", trend: "text-[10px]" },
    md: { score: "text-4xl", label: "text-[10px]", trend: "text-[11px]" },
    lg: { score: "text-5xl", label: "text-xs", trend: "text-xs" },
  };
  const v = variants[size] || variants.md;

  const Wrapper = onClick ? "button" : "div";

  return (
    <Wrapper
      onClick={onClick}
      data-testid={testid || "health-score"}
      className={`flex items-center gap-2.5 ${onClick ? "hover:opacity-90 transition-opacity cursor-pointer text-left" : ""}`}
    >
      <div className={`font-display font-bold leading-none ${v.score}`} style={{ color }}>
        {score}
      </div>
      <div className="flex flex-col gap-0.5">
        <div
          className={`font-mono ${v.label} uppercase tracking-[0.18em] font-semibold`}
          style={{ color }}
        >
          {status}
        </div>
        <div className={`inline-flex items-center gap-1 font-mono ${v.trend}`} style={{ color: trendColor }}>
          <TrendIcon size={size === "xs" ? 10 : size === "sm" ? 11 : 12} />
          <span>{trend.label}</span>
          <span className="text-[var(--fop-text-4)] ml-0.5">7d</span>
        </div>
      </div>
    </Wrapper>
  );
}

export function HealthBadge({ health }) {
  if (!health || health.score == null) return null;
  const color = BAND_COLORS[health.status?.band] || "#9899a5";
  return (
    <span
      className="pill"
      style={{ color, background: `${color}18`, borderColor: `${color}40` }}
      data-testid="health-pill"
    >
      <span className="pill-dot" />
      {health.score} · {health.status?.label}
    </span>
  );
}
